<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <!-- <el-input class="search-el" size="small" v-model="query.title" placeholder="请输入标题"></el-input>
    <el-button type="primary" size="small" @click="getList()">
      查询
    </el-button> -->
        <el-button type="primary" size="mini" @click="createInfo()">
          添加
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisibleImport = true"
        >
          导入
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column prop="id" label="ID" align="center" min-width="5%"></el-table-column>

        <el-table-column
          prop="title"
          label="组长"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateHandle(row)">
              <div>{{ row.title }}</div>
            </el-button>
        </template> 
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          min-width="10%"
        ></el-table-column>
        <el-table-column
          prop="number"
          label="小组编号"
          align="center"
          min-width="6%"
        ></el-table-column>

        <el-table-column
          prop="department_id"
          label="组长归属"
          align="center"
          min-width="8%"
        >
          <template slot-scope="{ row }">
            <el-select
              ref="multiSelect"
              class="search-el"
              size="mini"
              v-model="row.department_id"
              placeholder="组长归属"
              filterable
              @change="updateGroupOrParentDepartment($event, row.id, 'group')"
            >
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column
          prop="nickname"
          label="区长昵称"
          align="center"
          min-width="10%"
        ></el-table-column>
        <el-table-column
          prop="mobile_phone"
          label="区长手机号"
          align="center"
          min-width="10%"
        ></el-table-column>

        <el-table-column
          prop="parent_department_id"
          label="区长归属"
          align="center"
          min-width="8%"
        >
          <template slot-scope="{ row }">
            <el-select
              ref="multiSelect"
              class="search-el"
              size="mini"
              v-model="row.parent_department_id"
              placeholder="区长归属"
              filterable
              @change="updateGroupOrParentDepartment($event, row.id, 'warden')"
            >
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column
          prop="object_relations_count"
          label="组成员/已签到"
          align="center"
          min-width="5%"
        >
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toMeetObjectRelation(row.id)">
              <div>{{ row.object_relations_count }}</div>
            </el-button>
            /&nbsp;{{ row.object_relations_present }}
        </template> 
        
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          min-width="12%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">

            <el-button
              type="danger" icon="el-icon-delete"
              @click="groupListDelete(row.id)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="小组"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <el-form :model="topicTemp" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="topicTemp.name"
            maxlength="30"
            show-word-limit
            placeholder="请输入组长姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="topicTemp.mobile"
            minlength="11"
            maxlength="11"
            show-word-limit
            placeholder="请输入组长手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="小组编号">
          <el-input
              type="number"
              min="0"
            v-model="topicTemp.num"
            placeholder="请输入小组编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="区长手机号">
          <el-input
            v-model="topicTemp.parent_mobile"
            minlength="11"
            maxlength="11"
            show-word-limit
            placeholder="请输入区长手机号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="create == false ? updateTopic() : createTopic()"
            :loading="updateLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 上传导入 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogVisibleImport"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <el-upload
        class="upload-demo"
        :action="ossAction"
        :show-file-list="false"
        :http-request="uploadOSSRequest"
      >
        <el-button size="small" type="primary">导入</el-button>
        <div slot="tip" class="el-upload__tip">
          <el-link
            :underline="false"
            type="primary"
            href="https://res.defen.hzxinquanzi.com/activity/%E5%88%86%E7%BB%84%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
            target="_blank"
            >下载模板文件</el-link
          >
          <p>1.请下载模板文件</p>
          <p>2.补充填入所需数据，小组与区长关联，并且确保组长与区长必须是灵动生活正常用户</p>
          <p>3.禁止空行数据</p>
          <p>4.保存上传</p>
        </div>
      </el-upload>
    </el-dialog>

    <div class="hides" v-if="updateLoading" style="position: relative; z-index: 5000; opacity: 0.2;">
      <i style="margin-top: 20px; font-size: 40px" class="el-icon-loading"> </i
      ><br />
      正在上传
    </div>
  </div>
</template>

<script>
import { uploadOSSRequest, getAliyunOssToken } from "@/api/common";

import {
  meetGroupList,
  groupListDelete,
  createMeetGroup,
  updateMeetGroup,
  importGroupList,
  updateGroupOrParentDepartment
} from "@/api/activity";

export default {
  data: function () {
    return {
      ossAction: "",
      dialogVisibleImport: false,
      activityId: 0,
      dialogVisible: false,
      create: false,
      list: [],
      departmentList: [],
      loading: false,
      updateLoading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        activity_id: 0,
        name: "",
      },
      topicTemp: {
        activity_id: 0,
        name: "",
        mobile: "",
        num: 0,
        parent_mobile: "",
      },
    };
  },
  created: function () {
    this.activityId = this.$route.query.activity_id;
    this.query.activity_id = this.activityId;
    this.topicTemp.activity_id = this.activityId;
    this.getList();
  },
  methods: {
    toMeetObjectRelation(id) {
      this.$router.push({
        path: '/activity/meetObjectRelation',
        query: {
          activity_id: this.activityId,
          object_id: id,
        }
      })
    },

    uploadOSSRequest(file) {
      this.updateLoading = true;
      getAliyunOssToken({ dir: "activity/" + this.activityId + "/" }).then(
        (res) => {
          uploadOSSRequest(file.file, res.data).then((fileUrl) => {
            importGroupList({
              activity_id: this.activityId,
              url: fileUrl,
            }).then((res) => {
              if (res.status == 2000) {
                this.updateLoading = false;

                this.$confirm(res.message, "导入结果", {
                  confirmButtonText: "确定",
                  type: "info",
                })
                  .then(() => {
                    this.dialogVisibleImport = false;
                    this.getList();
                  })
                  .catch(() => {
                    this.dialogVisibleImport = false;
                    this.getList();
                  });
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          });
        }
      );
    },

    tempReset() {
      this.topicTemp = {
        activity_id: this.activityId,
        name: "",
        mobile: "",
        num: 0,
        parent_mobile: "",
      };
    },
    createInfo() {
      this.create = true;
      this.dialogVisible = true;
      this.tempReset();
    },
    createTopic() {
      console.log(this.topicTemp);
      createMeetGroup(this.topicTemp)
        .then((response) => {
          this.updateLoading = false;
          if (response.status === "2000") {
            this.tempReset();
            this.$message.success(response.message);
            this.getList();
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    updateHandle(row) {
      //this.topicTemp = Object.assign({}, row)
      this.topicTemp = {
        id: row.id,
        activity_id: this.activityId,
        name: row.title,
        mobile: row.mobile,
        num: row.number,
        parent_mobile : row.mobile_phone,
      };
      this.dialogVisible = true;
      this.create = false;
    },
    updateTopic() {      
      updateMeetGroup(this.topicTemp).then((response) => {
        this.updateLoading = false;
        console.log(response);
        if (response.status === "2000") {
          this.$message.success(response.message);
          this.getList();
          this.dialogVisible = false;
        } else {
          this.dialogVisible = false;
        }
      });
    },

    getList(str) {
      this.loading = true;
      meetGroupList(this.query).then((response) => {
        this.list = response.data.list;
        this.departmentList = response.data.meet_department;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    groupListDelete(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        groupListDelete({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    updateGroupOrParentDepartment(event, id, type) {
      if (type == 'group') {
        var msg = '确定要更改组长所属归属吗？';
      } else {
        var msg = '确定要更改区长所属归属吗？'
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateGroupOrParentDepartment({
          id: id,
          department_id: event,
          type: type
        })
          .then((response) => {
            if (response.status == 2000) {
              setTimeout(() => {
                this.$refs.multiSelect.blur();
              }, 50);
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
      }).catch(() => {});
    },
  },
  mounted() {},
};
</script>

<style>
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>